import React, { useEffect, useState } from 'react'

import { get, post } from '../../config/fetch'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { Phone } from '@material-ui/icons'

import Total from './total'
import RadialBar from './radialbar'
import BarIncidents from './barincidents'
import ProgressBar from './progressbar'
import { green } from '@material-ui/core/colors'
import CircularProgress from '@material-ui/core/CircularProgress'
import BarHorizontal from '../dashboard/barhorizontal'
import BarTopIncidents from './bartopincidents'
import LineIncidents from './lineincidents'
import { Accordion } from '@material-ui/core'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import DateFnsUtils from '@date-io/date-fns'
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import RadialIncidents from './radialIncidents'
import Button from '@material-ui/core/Button'
import { TOKEN_GET_DEVICES_BRAND, TOKEN_GET_DEVICES_LIST, TOKEN_INCIDENTS_BY_DATE } from '../../constants/constants'

const drawerWidth = 240

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        background: 'black'
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        magin: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        backgroundColor: '#06171E',
    },
    paper2: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    fixedHeight: {
        height: 705,
    },
    fixedHeight2: {
        height: 135,
    },
    fixedHeight3: {
        height: 450,
    },
}))

export default function Incidents() {
    const classes = useStyles()
    const today = new Date()
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
    const fixedHeightPaper2 = clsx(classes.paper, classes.fixedHeight2)
    const fixedHeightPaper3 = clsx(classes.paper, classes.fixedHeight3)
    const [dashboardData, setDashboardData] = useState()
    const [dashboardNetData, setDashboardNetData] = useState()
    const [noIncidentsNetData, setNoIncidentsNetData] = useState()

    const [incidentsDayData, setIncidentsDayData] = useState()
    const [incidentsNetDayData, setIncidentsNetDayData] = useState()

    //const [topIncidentsRSSIData, setTopIncidentsRSSIData] = useState()
    const [topIncidentsRSRQData, setTopIncidentsRSRQData] = useState()
    const [topIncidentsRSRPData, setTopIncidentsRSRPData] = useState()
    const [topIncidentsRSSNRData, setTopIncidentsRSSNRData] = useState()
    const [topIncidentsRoamingData, setTopIncidentsRoamingData] = useState()
    const [topIncidentsVolteData, setTopIncidentsVolteData] = useState()
    const [topIncidentsMobileData, setTopIncidentsMobileData] = useState()
    const [topIncidentsBatteryData, setTopIncidentsBatteryData] = useState()

    const [incidentType, setIncidentType] = useState('user')
    const [devicesBrand, setDevicesBrand] = useState()
    const [devicesList, setDevicesList] = useState()
    const [startDate, setStartDate] = useState(
        new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0),
    )
    const [endDate, setEndDate] = useState(
        new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59),
    )

    const [deviceIdBrand, setDeviceIdBrand] = useState('')
    const [deviceIdList, setDeviceIdList] = useState('')
    const [columsGrid, setColumnsGrid] = useState(12)
    
    const [isLoading, setLoading] = useState(true)
    const [isLoadingByDate, setLoadingByDate] = useState(true)
    const [visiblePopover, setVisiblePopover] = useState(false)

    const fetchDevicesBrand = async () => {
        try {
            const response = await get(
                `/devicesBrand?code=${TOKEN_GET_DEVICES_BRAND}`,
            )
            setDevicesBrand(response.data);
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchDevicesList = async () => {
        try {
            const response = await get(
                `/devicesList?code=${TOKEN_GET_DEVICES_LIST}`,
            )
            setDevicesList(response.data);
        } catch (e) {
            throw new Error(e)
        }
    }


    const fetchDashboardData = async (startD, endD, devicesIdL, deviceIdB) => {
        try {
            //setLoading(true)
            const response = await get(
                `/incidentsKpi?code=KcgCgyjPxDll6cpCvJbvJpMoWdFuh93YVu/oq5sVJ0AlwK3PanfR/Q==&startDate=${startD}&endDate=${endD}&deviceIdList=${devicesIdL || ''}&deviceIdBrand=${deviceIdB || ''}`,
            )
            //setDashboardData(response.data)
            //setLoading(false)
            categoriesIncidentsUser(response.data);
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchDashboardNetData = async (startD, endD, devicesIdL, deviceIdB) => {
        try {
            setLoading(true)
            console.log('deviceIdB: ', deviceIdB);
            const response = await get(
                `/incidentsNetwork?startDate=${startD}&endDate=${endD}&deviceIdList=${devicesIdL || ''}&deviceIdBrand=${deviceIdB || ''}`,
            )
            //setDashboardNetData(response.data)
            setLoading(false)
            categoriesIncidents(response.data);
            //return response.data;
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchIncidentsDayData = async data => {
        try {
            setLoadingByDate(true)
            const response = await get(
                `/incidentsByDate?code=${TOKEN_INCIDENTS_BY_DATE}`,
            )
            setIncidentsDayData(response.data)
            setLoadingByDate(false)
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchIncidentsNetDayData = async data => {
        try {
            setLoadingByDate(true)
            const response = await get(
                `/incidentsNetByDate?code=cgTouy6yx4t/uWh4Nf5HU71eDG7Y8yrwf3pDPdMDxLHOHdsvapS/dQ==`,
            )
            setIncidentsNetDayData(response.data)
            setLoadingByDate(false)
        } catch (e) {
            throw new Error(e)
        }
    }

    useEffect( () => {
        fetchDevicesBrand();
        fetchDevicesList();
        setDashboardNetData([0, 0, 0]);
        setNoIncidentsNetData([0, 0, 0]);
        setDashboardData([0, 0, 0, 0]);
        //setLoading(false)
        //setIncidentType('network');
        //fetchDashboardData();
        //fetchIncidentsDayData();
        //fetchIncidentsNetDayData();
        fetchDashboardData(startDate, endDate, deviceIdList, deviceIdBrand);
        //await categoriesIncidents();
        //fetchDashboardNetData(deviceIdBrand);
    }, []);
    
    const categoriesIncidents = (incidentsNet) => {
        let dataCategories = [0, 0, 0];
        let dataCategoriesNoInc = [0, 0, 0];
        let topRSSI = [];
        let topRSRQ = [];
        let topRSRP = [];
        let topRSSNR = [];
        //const incidentsNet = await fetchDashboardNetData();
        console.log('incidentsNet: ', incidentsNet);

        //const incidentsRSSI = incidentsNet.incidentsKpi.filter(r => r.type === "RSSI")[0].incidents;
        const incidentsRSRQ = incidentsNet.incidentsKpi.filter(r => r.type === "RSRQ")[0].incidents;
        const incidentsRSRP = incidentsNet.incidentsKpi.filter(r => r.type === "RSRP")[0].incidents;
        const incidentsRSSNR = incidentsNet.incidentsKpi.filter(r => r.type === "RSSNR")[0].incidents;

        /*
        incidentsRSSI.forEach(value => {
            dataCategories[0] += value.countIncident;
        });
        */
        incidentsRSRP.forEach(value => {
            dataCategories[0] += value.countIncident;
        });
        incidentsRSRQ.forEach(value => {
            dataCategories[1] += value.countIncident;
        });
        incidentsRSSNR.forEach(value => {
            dataCategories[2] += value.countIncident;
        });

        //incidentsRSSI.sort((a, b) => b.countIncident - a.countIncident);
        incidentsRSRP.sort((a, b) => b.countIncident - a.countIncident);
        incidentsRSRQ.sort((a, b) => b.countIncident - a.countIncident);
        incidentsRSSNR.sort((a, b) => b.countIncident - a.countIncident);
        
        let length = incidentsRSRP.length >= 5 ? 5 : incidentsRSRP.length;
        for (let i = 0; i < length; i++) {
            topRSRP.push({ name: incidentsRSRP[i].msisdn, value: incidentsRSRP[i].countIncident });
        }
        length = incidentsRSRQ.length >= 5 ? 5 : incidentsRSRQ.length;
        for (let i = 0; i < length; i++) {
            topRSRQ.push({ name: incidentsRSRQ[i].msisdn, value: incidentsRSRQ[i].countIncident });
        }
        length = incidentsRSSNR.length >= 5 ? 5 : incidentsRSSNR.length;
        for (let i = 0; i < length; i++) {
            topRSSNR.push({ name: incidentsRSSNR[i].msisdn, value: incidentsRSSNR[i].countIncident });
        }
        /*
        length = incidentsRSSI.length >= 5 ? 5 : incidentsRSSI.length;
        for (let i = 0; i < length; i++) {
            topRSSI.push({ name: incidentsRSSI[i].deviceId, value: incidentsRSSI[i].countIncident });
        }
        */

        //this.ramps.sort((a, b) => this.sortTypeId === 1 ? a.number - b.number : b.number - a.number);

        //console.log('topRSSI: ', topRSSI);
        
        //console.log('incidentsRSSI: ', incidentsRSSI);
        console.log('incidentsRSRP: ', incidentsRSRP);
        console.log('incidentsRSRQ: ', incidentsRSRQ);
        console.log('incidentsRSRP: ', incidentsRSSNR);
        console.log('dataCategories: ', dataCategories);

        //const noIncidentsRSSI = incidentsNet.noIncidentsKpi.filter(r => r.type === "RSSI")[0].incidents[0].countNoIncident;
        const noIncidentsRSRP = incidentsNet.noIncidentsKpi.filter(r => r.type === "RSRP")[0].incidents[0].countNoIncident;
        const noIncidentsRSRQ = incidentsNet.noIncidentsKpi.filter(r => r.type === "RSRQ")[0].incidents[0].countNoIncident;
        const noIncidentsRSSNR = incidentsNet.noIncidentsKpi.filter(r => r.type === "RSSNR")[0].incidents[0].countNoIncident;

        //console.log('noIncidentsRSSI: ', noIncidentsRSSI);
        console.log('noIncidentsRSRP: ', noIncidentsRSRP);
        console.log('noIncidentsRSRQ: ', noIncidentsRSRQ);
        console.log('noIncidentsRSSNR: ', noIncidentsRSSNR);

        //dataCategoriesNoInc[0] = noIncidentsRSSI;
        dataCategoriesNoInc[0] = noIncidentsRSRP;
        dataCategoriesNoInc[1] = noIncidentsRSRQ;
        dataCategoriesNoInc[2] = noIncidentsRSSNR;
        
        setDashboardNetData(dataCategories);
        setNoIncidentsNetData(dataCategoriesNoInc);
        
        //setTopIncidentsRSSIData(topRSSI);
        setTopIncidentsRSRPData(topRSRP);
        setTopIncidentsRSRQData(topRSRQ);
        setTopIncidentsRSSNRData(topRSSNR);

        setLoading(false)
    }

    const categoriesIncidentsUser = (incidentsUser) => {
        let dataCategories = [0, 0, 0, 0];
        let topRoaming = [];
        let topVolte = [];
        let topMobile = [];
        let topBattery = [];
        //const incidentsNet = await fetchDashboardNetData();
        console.log('incidentsUser: ', incidentsUser);

        const incidentsRoaming = incidentsUser.incidentsKpi.filter(r => r.type === "Roaming")[0].incidents;
        const incidentsVoLTE = incidentsUser.incidentsKpi.filter(r => r.type === "VoLTE")[0].incidents;
        const incidentsMobileData = incidentsUser.incidentsKpi.filter(r => r.type === "MobileData")[0].incidents;
        const incidentsBattery = incidentsUser.incidentsKpi.filter(r => r.type === "Battery")[0].incidents;

        incidentsRoaming.forEach(value => {
            dataCategories[0] += value.countIncident;
        });
        incidentsVoLTE.forEach(value => {
            dataCategories[1] += value.countIncident;
        });
        incidentsMobileData.forEach(value => {
            dataCategories[2] += value.countIncident;
        });
        incidentsBattery.forEach(value => {
            dataCategories[3] += value.countIncident;
        });

        incidentsRoaming.sort((a, b) => b.countIncident - a.countIncident);
        incidentsVoLTE.sort((a, b) => b.countIncident - a.countIncident);
        incidentsMobileData.sort((a, b) => b.countIncident - a.countIncident);
        incidentsBattery.sort((a, b) => b.countIncident - a.countIncident);

        let length = incidentsRoaming.length >= 5 ? 5 : incidentsRoaming.length;
        for (let i = 0; i < length; i++) {
            topRoaming.push({ name: incidentsRoaming[i].model, value: incidentsRoaming[i].countIncident });
        }
        length = incidentsVoLTE.length >= 5 ? 5 : incidentsVoLTE.length;
        for (let i = 0; i < length; i++) {
            topVolte.push({ name: incidentsVoLTE[i].model, value: incidentsVoLTE[i].countIncident });
        }
        length = incidentsMobileData.length >= 5 ? 5 : incidentsMobileData.length;
        for (let i = 0; i < length; i++) {
            topMobile.push({ name: incidentsMobileData[i].model, value: incidentsMobileData[i].countIncident });
        }
        length = incidentsBattery.length >= 5 ? 5 : incidentsBattery.length;
        for (let i = 0; i < length; i++) {
            topBattery.push({ name: incidentsBattery[i].model, value: incidentsBattery[i].countIncident });
        }
        

        console.log('incidentsRoaming: ', incidentsRoaming);
        console.log('incidentsVoLTE: ', incidentsVoLTE);
        console.log('incidentsMobileData: ', incidentsMobileData);
        console.log('dataCategories: ', dataCategories);

        setDashboardData(dataCategories)

        setTopIncidentsRoamingData(topRoaming);
        setTopIncidentsVolteData(topVolte);
        setTopIncidentsMobileData(topMobile);
        setTopIncidentsBatteryData(topBattery);
        
        setLoading(false)
    }

    const handleChangeIncidentType = e => {
        console.log('evento: ', e);
        console.log('evento: ', e.target.value);
        setIncidentType(e.target.value);
        
        if (e.target.value === 'user' || e.target.value === 'all') {
            fetchDashboardData(startDate, endDate, deviceIdList, deviceIdBrand);
            //fetchIncidentsDayData();
        } 
        if (e.target.value === 'network' || e.target.value === 'all') {
            fetchDashboardNetData(startDate, endDate, deviceIdList, deviceIdBrand);
            //fetchDashboardNetData();
            //fetchIncidentsNetDayData();
        }
        if (e.target.value === 'all') {
            setColumnsGrid(6);
        } else {
            setColumnsGrid(12);
        }
    }

    const handleDate = date => {
        const startD = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0);
        const endD = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59);
        setStartDate(startD);
        setEndDate(endD);
        if (incidentType === 'user' || incidentType === 'all') {
            fetchDashboardData(startD, endD, deviceIdList, deviceIdBrand);
        }
        if (incidentType === 'network' || incidentType === 'all') {
            fetchDashboardNetData(startD, endD, deviceIdList, deviceIdBrand);
        }
    }

    const handleChangeDevicesBrand = async e => {
        console.log('evento: ', e);
        console.log('evento: ', e.target.value);
        
        setDeviceIdBrand(e.target.value);
        //await categoriesIncidents();
        //setDevicesBrand();
        if (incidentType === 'user' || incidentType === 'all') {
            fetchDashboardData(startDate, endDate, deviceIdList, e.target.value);
        }
        if (incidentType === 'network' || incidentType === 'all') {
            fetchDashboardNetData(startDate, endDate, deviceIdList, e.target.value);
        }
    }

    const handleChangeDevicesList = async e => {
        console.log('evento: ', e.target.value);
        setDeviceIdList(e.target.value);
        //setDeviceIdBrand(e.target.value);
        //await categoriesIncidents();
        //setDevicesBrand();
        if (incidentType === 'user' || incidentType === 'all') {
            fetchDashboardData(startDate, endDate, e.target.value, deviceIdBrand);
        }
        if (incidentType === 'network' || incidentType === 'all') {
            fetchDashboardNetData(startDate, endDate, e.target.value, deviceIdBrand);
        }
    }

    const handleChangeAccordion = () => {
        setVisiblePopover(!visiblePopover)
    }

    return (
        <div className={classes.root}>
        
            <Container maxWidth="lg" className={classes.container}> 
                { isLoading ?
                <Grid container justify = "center">
                    <CircularProgress />
                </Grid> :
                <>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Accordion expanded={visiblePopover} onChange={handleChangeAccordion}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel-header"
                                >
                                    <Typography>Filters</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel shrink id="incident-type-label">
                                            Incident type
                                        </InputLabel>
                                        <Select
                                            labelId="incident-type-label"
                                            value={incidentType || ''}
                                            style={{width: '90%'}}
                                            onChange={handleChangeIncidentType}
                                        >
                                            <MenuItem value="user">User Incidents</MenuItem>
                                            <MenuItem value="network">Network Incidents</MenuItem>
                                            <MenuItem value="all">All incidents</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel shrink id="devices-list-label">
                                            Devices list
                                        </InputLabel>
                                        <Select
                                            labelId="devices-list-label"
                                            value={deviceIdList || ''}
                                            style={{width: '90%'}}
                                            onChange={handleChangeDevicesList}
                                            displayEmpty
                                        >
                                            <MenuItem value="">
                                                <em>Select all device list</em>
                                            </MenuItem>
                                            {devicesList.map(item => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel shrink id="devices-brand-label">
                                            Devices brand
                                        </InputLabel>
                                        <Select
                                            labelId="devices-brand-label"
                                            value={deviceIdBrand || ''}
                                            style={{width: '90%'}}
                                            onChange={handleChangeDevicesBrand}
                                            displayEmpty
                                        >
                                            <MenuItem value="">
                                                <em>Select all devices brand</em>
                                            </MenuItem>
                                            {devicesBrand.map(item => (
                                                <MenuItem key={item.brand} value={item.brand}>
                                                    {item.brand}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <AccordionDetails className={classes}>
                                                <KeyboardDatePicker
                                                    id="date-picker-dialog"
                                                    label="Filter date"
                                                    format="MM/dd/yyyy"
                                                    value={startDate}
                                                    onChange={handleDate}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                />
                                            </AccordionDetails>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                    {
                        incidentType === 'network' || incidentType === 'all' ?
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Paper className={fixedHeightPaper2}>
                                        <Total
                                            titulo="RSRP Incidents"
                                            total={dashboardNetData[0]}
                                            leyenda="RSRP Incidents (less than -110 dBm)"
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Paper className={fixedHeightPaper2}>
                                        <Total
                                            titulo={'RSRQ Incidents'}
                                            total={dashboardNetData[1]}
                                            leyenda={'RSRQ Incidents (less than -20 dB)'}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Paper className={fixedHeightPaper2}>
                                        <Total
                                            titulo={'RSSNR Incidents'}
                                            total={dashboardNetData[2]}
                                            leyenda={'RSSNR Incidents (less than -5)'}
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>
                            : <></>
                    }
                    {
                        incidentType === 'user' || incidentType === 'all' ?
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Paper className={fixedHeightPaper2}>
                                        <Total
                                            titulo="Roaming Incidents"
                                            total={dashboardData[0]}
                                            leyenda="Roaming Incidents"
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Paper className={fixedHeightPaper2}>
                                        <Total
                                            titulo="VoLTE Incidents"
                                            total={dashboardData[1]}
                                            leyenda="VoLTE Incidents"
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Paper className={fixedHeightPaper2}>
                                        <Total
                                            titulo="MobileData Incidents"
                                            total={dashboardData[2]}
                                            leyenda="MobileData Incidents"
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Paper className={fixedHeightPaper2}>
                                        <Total
                                            titulo="Baterry Incidents"
                                            total={dashboardData[3]}
                                            leyenda="Baterry Incidents"
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>
                            : <></>
                    }
                <Grid container spacing={3}>
                    {
                        incidentType === 'network' || incidentType === 'all' ?
                            <Grid item xs={12} sm={12} md={columsGrid}>
                                <Grid item xs={12}>
                                    <Paper className={fixedHeightPaper3}>
                                        <BarIncidents
                                            title={'Total Incidents Network'}
                                            categories= {
                                                ['RSRQ', 'RSRP', 'RSSNR']
                                            }
                                            data={dashboardNetData}
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>
                            : <></>
                    }
                    {
                        incidentType === 'user' || incidentType === 'all' ?
                            <Grid item xs={12} sm={12} md={columsGrid}>
                                <Grid item xs={12}>
                                    <Paper className={fixedHeightPaper3}>
                                        <BarIncidents
                                            title={'Total Incidents User'}
                                            categories= {
                                                ['Roaming', 'VoLTE', 'MobileData', 'Battery']
                                            }
                                            data={dashboardData}
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>
                            : <></>
                    }
                </Grid>
                    {
                        incidentType === 'network' || incidentType === 'all' ?
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Grid item xs={12} style={{ marginBottom: '1em' }}>
                                        <Paper className={fixedHeightPaper3}>
                                            <RadialIncidents
                                                title={'% incidents RSRP'}
                                                values={dashboardNetData ?
                                                    [{
                                                        title: 'Incidents RSRP',
                                                        total: dashboardNetData[0],
                                                        color: "#FF0000"
                                                    },{
                                                        title: 'No Incidents RSRP',
                                                        total: noIncidentsNetData[0],
                                                        color: "#1bc943"
                                                    }]
                                                    : []}
                                            />
                                        </Paper>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Grid item xs={12} style={{ marginBottom: '1em' }}>
                                        <Paper className={fixedHeightPaper3}>
                                            <RadialIncidents
                                                title={'% incidents RSRQ'}
                                                values={dashboardNetData ?
                                                    [{
                                                        title: 'Incidents RSRQ',
                                                        total: dashboardNetData[1],
                                                        color: "#FF0000"
                                                    },{
                                                        title: 'No Incidents RSRQ',
                                                        total: noIncidentsNetData[1],
                                                        color: "#1bc943"
                                                    }]
                                                    : []}
                                            />
                                        </Paper>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Grid item xs={12} style={{ marginBottom: '1em' }}>
                                        <Paper className={fixedHeightPaper3}>
                                            <RadialIncidents
                                                title={'% incidents RSSNR'}
                                                values={dashboardNetData ?
                                                    [{
                                                        title: 'Incidents RSSNR',
                                                        total: dashboardNetData[2],
                                                        color: "#FF0000"
                                                    },{
                                                        title: 'No Incidents RSSNR',
                                                        total: noIncidentsNetData[2],
                                                        color: "#1bc943"
                                                    }]
                                                    : []}
                                            />
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Grid>
                            :
                            <></>
                    }

                    {
                        incidentType === 'network' || incidentType === 'all' ?
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Paper className={fixedHeightPaper3}>
                                        <BarTopIncidents
                                            title={'Top 5 Devices RSRP'}
                                            categories= {
                                                topIncidentsRSRPData && topIncidentsRSRPData.length > 0 && topIncidentsRSRPData.map((b) => b.name)
                                            }
                                            data={topIncidentsRSRPData && topIncidentsRSRPData.length > 0 && topIncidentsRSRPData.map((b) => b.value)}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Paper className={fixedHeightPaper3}>
                                        <BarTopIncidents
                                            title={'Top 5 Devices RSRQ'}
                                            categories= {
                                                topIncidentsRSRQData && topIncidentsRSRQData.length > 0 && topIncidentsRSRQData.map((b) => b.name)
                                            }
                                            data={topIncidentsRSRQData && topIncidentsRSRQData.length > 0 && topIncidentsRSRQData.map((b) => b.value)}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Paper className={fixedHeightPaper3}>
                                        <BarTopIncidents
                                            title={'Top 5 Devices RSSNR'}
                                            categories= {
                                                topIncidentsRSSNRData && topIncidentsRSSNRData.length > 0 && topIncidentsRSSNRData.map((b) => b.name)
                                            }
                                            data={topIncidentsRSSNRData && topIncidentsRSSNRData.length > 0 && topIncidentsRSSNRData.map((b) => b.value)}
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>            
                            :
                            <></>
                    }

                    {
                        incidentType === 'user' || incidentType === 'all' ?
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Grid item xs={12} style={{ marginBottom: '1em' }}>
                                        <Paper className={fixedHeightPaper3}>
                                            <RadialBar
                                                title={'% by user incidents'}
                                                values={dashboardData && dashboardData.length > 0 ?
                                                    [{
                                                        title: 'Roaming',
                                                        total: dashboardData[0]
                                                    },{
                                                        title: 'VoLTE',
                                                        total: dashboardData[1]
                                                    },{
                                                        title: 'Mobile Data',
                                                        total: dashboardData[2]
                                                    },{
                                                        title: 'Battery',
                                                        total: dashboardData[3]
                                                    }]
                                                    : []}
                                            />
                                        </Paper>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Paper className={fixedHeightPaper3}>
                                        <BarTopIncidents
                                            title={'Top 5 Devices user incidents'}
                                            categories= {
                                                topIncidentsRoamingData.length > 0 && topIncidentsRoamingData.map((b) => b.name)
                                            }
                                            data={topIncidentsRoamingData.length > 0 && topIncidentsRoamingData.map((b) => b.value)}
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>
                            :
                            <></>
                    }

                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                        style={{ margin: '2em 0' }}
                    >
                        <Grid xs={11} container direction="row" justify="flex-end" alignItems="center">
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                onClick={()=> window.open("https://app.powerbi.com/groups/me/reports/4a85ad9e-e531-4cc1-85dd-2e9363f33fc3/ReportSection17fc522a10dc80a8ac14", "_blank")}
                            >
                                See more...
                            </Button>
                        </Grid>
                    </Grid>
                    

{/*
                    {
                        incidentType === 'network' ?
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Grid item xs={12} style={{ marginBottom: '1em' }}>
                                        <Paper className={fixedHeightPaper3}>
                                            <RadialIncidents
                                                title={'Total users vs users incidents'}
                                                values={dashboardNetData ?
                                                    [{
                                                        title: 'Total users',
                                                        total: 16,
                                                        color: "#FF0000"
                                                    },{
                                                        title: 'Users incidents',
                                                        total: 5,
                                                        color: "#1bc943"
                                                    }]
                                                    : []}
                                            />
                                        </Paper>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Grid item xs={12} style={{ marginBottom: '1em' }}>
                                        <Paper className={fixedHeightPaper3}>
                                            <RadialIncidents
                                                title={'Time incidents'}
                                                values={dashboardNetData ?
                                                    [{
                                                        title: 'Time with incidents',
                                                        total: 2,
                                                        color: "#FF0000"
                                                    },{
                                                        title: 'Time with no incidents',
                                                        total: 12,
                                                        color: "#1bc943"
                                                    }]
                                                    : []}
                                            />
                                        </Paper>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}>
                                    <Grid item xs={12} style={{ marginBottom: '1em' }}>
                                        <Paper className={fixedHeightPaper3}>
                                            <RadialIncidents
                                                title={'Incidents by brand'}
                                                values={dashboardNetData ?
                                                    [{
                                                        title: 'Incidents SAMSUMG',
                                                        total: 34,
                                                        color: "#FF0000"
                                                    },{
                                                        title: 'No Incidents',
                                                        total: 125,
                                                        color: "#1bc943"
                                                    }]
                                                    : []}
                                            />
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Grid>
                            
                            
                            :
                            <></>
                    }
*/}
                    
                </>}

{/*
                {isLoadingByDate ?
                    <Grid container justify="center">
                        <CircularProgress />
                    </Grid> :
                    <>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Grid item xs={12}>
                                <Paper className={fixedHeightPaper3}>
                                    <LineIncidents
                                        title={'Incidents by date'}
                                        categories= {incidentsDayData && incidentsDayData.incidents.map((b) => {
                                            return new Intl.DateTimeFormat("en-GB", {
                                                year: "numeric",
                                                month: "long",
                                                day: "2-digit"
                                            }).format(new Date(b.createdAt))
                                        })}
                                        data={incidentsDayData && incidentsDayData.incidents.map((b) => b.countIncident)}
                                    />
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    </>
                }
*/}
            </Container>
        </div>
    )
}
